module.exports = __webpack_public_path__ + "img/contact-book.e58d95da.png";